import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';
import { type CssColorKey } from 'config/branding/colors';
import { type CssVariable } from 'config/branding/types';

const sizes = {
    xsmall: {
        viewBox: '0 0 10 10',
        width: '10px',
        height: '10px',
        path: 'M3 1L7 5L3 9',
    },
    small: {
        viewBox: '0 0 12 12',
        width: '12px',
        height: '12px',
        path: 'M4 1L9 6L4 11',
    },
    medium: {
        viewBox: '0 0 16 16',
        width: '16px',
        height: '16px',
        path: 'M5 1L12 8L5 15',
    },
};
export type ChevronRightSizes = keyof typeof sizes;

export interface ChevronRightProps extends Record<string, unknown> {
    color?: CssVariable<CssColorKey> | 'currentColor';
    height?: string | string[];
    size?: ChevronRightSizes;
    width?: string | string[];
    viewBox?: string | string[];
}

export const ChevronRight = ({
    color = 'currentColor',
    size = 'small',
    height,
    width,
    viewBox,
    ...rest
}: ChevronRightProps) => {
    const selectedSize = sizes[size];
    return (
        <Svg
            width={width ?? selectedSize.width}
            height={height ?? selectedSize.height}
            viewBox={viewBox ?? selectedSize.viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <Path d={selectedSize.path} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </Svg>
    );
};

export default ChevronRight;
